<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 权限管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <el-input v-model="listQuery.id" placeholder="请输入ID" style="width:200px;"></el-input>
          <el-button
            class="filter-item"
            style="margin-left: 10px;"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
          >搜索</el-button>
          <el-button
            class="filter-item"
            style="margin-left: 10px;"
            type="primary"
            icon="el-icon-edit"
            @click="handleCreate"
          >添加</el-button>
        </div>

        <el-table border v-loading="listLoading" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="ID"/>
          <el-table-column prop="name" label="展示页面名称"/>
          <el-table-column prop="organ_id" label="组织"/>
          <el-table-column prop="role_id" label="角色"/>
          <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button
                type="primary"
                style="margin-right: 10px;"
                size="mini"
                @click="handleUpdate(scope.row)"
              >编辑</el-button>
              <el-popover placement="top" width="160" v-model="scope.row.deleteVisible">
                <p>确定删除吗?</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="scope.row.deleteVisible = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="handleDelete(scope.row)">确定</el-button>
                </div>
                <el-button slot="reference" size="mini" type="danger">删除</el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="handleList"
        />

        <el-dialog title="页面权限管理" width="60%" :visible.sync="dialogFormVisible">
          <el-form :model="formData" style="margin-left:50px;">
            <el-form-item label="ID" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="formData.id" :disabled="idDisabled"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="页面名称" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input clearable v-model="formData.name" placeholder="展示页面名称 最多64字"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="组织" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-select
                  v-model="formData.organ_id"
                  filterable
                  clearable 
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :loading="organLoading"
                >
                  <el-option
                    v-for="item in organOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="角色" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-select
                  v-model="formData.role_id"
                  filterable
                  clearable 
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :loading="roleLoading"
                >
                  <el-option
                    v-for="item in roleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleCreateUpdateStore">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  handleListApi,
  handleCreateStoreApi,
  handleDeleteApi,
  handleOrganListApi,
  handleRoleListApi
} from "@/api/admin_view_permission.js";
import Pagination from "@/components/pagination/index";

export default {
  components: { Pagination },
  data() {
    return {
      // 列表
      listLoading: false,
      total: 0,
      tableData: [],
      listQuery: {
        id: "",
        page: 1,
        limit: 10
      },
      // 表单
      dialogFormVisible: false,
      idDisabled: true,
      formData: {
        id: "",
        name: "",
        organ_id: "",
        role_id: ""
      },
      organLoading: false,
      organOptions: [],
      roleLoading: false,
      roleOptions: [],
      formLabelWidth: "120px",
      formInputWidth: "200px"
    };
  },
  created() {
    this.handleList(this.listQuery);
  },
  methods: {
    handleList() {
      this.listLoading = true;
      handleListApi(this.listQuery)
        .then(response => {
          const data = response.data.data;
          this.tableData = data;
          this.total = response.data.total;
          setTimeout(() => {
            this.listLoading = false;
          }, 0.5 * 1000);
        })
        .catch(error => {
          this.listLoading = false;
          console.log(error);
        });
    },
    handleResetForm() {
      this.formData.id = "";
      this.formData.name = "";
      this.formData.permissionDataRight = [];
    },
    handleFilter() {
      this.handleList(this.listQuery);
    },
    handleCreate() {
      this.handleResetForm();
      this.handleOrganList();
      this.handleRoleList();
      this.dialogFormVisible = true;
    },
    handleOrganList() {
      handleOrganListApi()
        .then(response => {
          const data = response.data;
          this.organOptions = data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleRoleList() {
      handleRoleListApi()
        .then(response => {
          const data = response.data;
          this.roleOptions = data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleCreateUpdateStore() {
      handleCreateStoreApi(this.formData)
        .then(response => {
          const data = response.data;
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.dialogFormVisible = false;
          this.handleList(this.listQuery);
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleUpdate(row) {
      this.dialogFormVisible = true;
      this.formData.id = row.id;
      this.formData.name = row.name;
      this.formData.role_id = row.role_id;
      this.formData.organ_id = row.organ_id ;
    },
    handleDownload() {
      console.log(13);
    },
    handleDelete(row) {
      handleDeleteApi(row)
        .then(response => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          row.deleteVisible = false;
          this.handleList(this.listQuery);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
<style scoped>
.pagination-container {
  background: #fff;
  padding: 32px 16px;
}
</style>
